import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';

export const CheckboxControlled = (props) => {
  const {
    type = 'text',
    id,
    labelText,
    placeholderText,
    extendClass = '',
    error,
    ariaRequired,
  } = props;
  const { control } = useFormContext();

  return (
    <div className={extendClass} data-testid="input-controlled">
      <Controller
        control={control}
        rules={{ required: true }}
        name={id}
        render={({ field: { onChange } }) => (
          <input
            type={type}
            id={id}
            name={id}
            onChange={onChange}
            data-testid={`input-${id}`}
            aria-required={ariaRequired}
            placeholder={placeholderText}
          />
        )}
      />
      <label htmlFor={id}>{labelText}</label>

      {error?.message && <p className="error-message">{error?.message}</p>}
    </div>
  );
};

CheckboxControlled.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  placeholderText: PropTypes.string,
  extendClass: PropTypes.string,
  ariaRequired: PropTypes.bool,
  error: PropTypes.object,
};
